"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MicroSurvey;
const react_1 = __importDefault(require("react"));
const shared_js_1 = require("../shared.js");
const queue_js_1 = __importDefault(require("./queue.js"));
const shared_data_1 = __importDefault(require("~/contexts/shared-data"));
require("./microsurvey-popup.scss");
function MicroSurvey() {
    const [QueuedItem, nextItem] = (0, queue_js_1.default)();
    const bottom = useBottom();
    const style = react_1.default.useMemo(() => (bottom ? { bottom } : {}), [bottom]);
    if (!QueuedItem) {
        return null;
    }
    return (react_1.default.createElement("div", { id: 'microsurvey', style: style },
        react_1.default.createElement(QueuedItem, { onDone: nextItem },
            react_1.default.createElement(shared_js_1.PutAway, { onClick: nextItem }))));
}
const SF_DURATION = 200; // sticky-footer animation duration
function useBottom() {
    const [value, setValue] = react_1.default.useState(0);
    const { stickyFooterState: [sfs] } = (0, shared_data_1.default)();
    react_1.default.useEffect(() => {
        if (sfs === null) {
            setValue(null);
        }
        const sf = document.querySelector('.sticky-footer');
        if (sf) {
            window.setTimeout(() => {
                const { top } = sf.getBoundingClientRect();
                setValue(window.innerHeight - top + 15);
            }, SF_DURATION);
        }
    }, [sfs]);
    return value;
}
